import { VueConstructor } from 'vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ptBR from 'vee-validate/dist/locale/pt_BR.json'

export function configureValidation(Vue: VueConstructor) {
    const validationRules = rules as Record<string, object>
    const messages = ptBR.messages as Record<string, string>

    Object.keys(rules).forEach(rule => {
        extend(rule, {
            ...validationRules[rule],
            message: messages[rule]
        })
    })

    Vue.component('ValidationObserver', ValidationObserver)
    Vue.component('ValidationProvider', ValidationProvider)
}
